import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MessageService } from 'primeng/api';
import { ETypeLien } from 'src/app/entites/enums/type-lien-document';
import { ToastModule } from 'primeng/toast';
import { DocumentComponent } from './document.component';

@Component({
    selector: 'app-public-document',
    templateUrl: './public-document.component.html',
    standalone: true,
    imports: [ToastModule, DocumentComponent]
})

export class PublicDocumentComponent implements OnInit {
    protected typeLienDocument: ETypeLien;
    protected idLien: number;
    protected numero: string;


    constructor(
        private route: ActivatedRoute,
        private messageService: MessageService
    ) { }

    ngOnInit() {
        //test
        this.typeLienDocument = ETypeLien.Emplacement;
        this.idLien = 10034;
        this.numero = "123456";
    }

}
